import { ITEM_TO_BAG } from "../constants";
import { CLEAR_ERRORS } from "../../common/constants";
import { getItemPrice } from "../selectors";

export const itemToBagIntent =
  ({ id, variantId, seller, source }) =>
  (dispatch, getState) => {
    dispatch({ type: CLEAR_ERRORS });
    const price = getItemPrice(getState(), id);
    dispatch({
      type: ITEM_TO_BAG,
      payload: { id, variantId, seller, source, price }
    });
  };
